import React from 'react'
import Edit from '../../assets/images/ic-edit.svg';
import DeleteBox from "../../assets/images/ic-deletebox.svg";
import { Table,Image } from 'react-bootstrap';
import { formatDate } from '../../constant/DateFormat';
const CompanyTable = ({filteredCompany,handleFormEdit}:{filteredCompany:any,handleFormEdit:any}) => {
  return (
    <Table className="table table-bordered table-striped" responsive>
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Domain Name</th>
              <th>Policy Source</th>
              <th>Valid from</th>
              <th>Valid till</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>            
            {filteredCompany?.length > 0 ? (
              filteredCompany?.map((item: any) => {
              return (
                <tr key={item.id}>
                  <td>{item.company} </td>
                  <td>{item.emailidDomain}</td>
                  <td>{item.policySource==true?<label> E&G</label>:<label>Rise 2.0</label>}</td>
                  <td>{formatDate(item.validFrom)}</td>
                  <td>{formatDate(item.validTill)}</td>    
                  <td>
                    <Image src={Edit} style={{marginRight:"25px"}} onClick={()=>handleFormEdit(item)}/>
                    {/* <Image src={DeleteBox} onClick={()=>handleShow1(item)}/> */}
                  </td>                  
                </tr>
              );
            })): (
              <span style={styles.text1}>No Records Available</span>
            )}
          
          </tbody>
        </Table>
  )
}
const styles: any = {
    text1: {
      fontFamily: "Saira",
      fontSize: "16px",
      fontWeight: "normal",
      border: "solid 1px #e4e4e4",
      borderTop: "0px",
      borderLeft: "0px",
      borderRight: "0px",
      color: "#6d6e71",
      textAlign: "left",
    },
}
export default CompanyTable